import React, {useContext, useEffect} from "react";
import {useFormikContext} from "formik";
import {ProcessingContext} from "../../contexts/ProcessingContext";

export interface IAutoSubmitting {
    updatedFieldsArray: string[]
}

export const AutoSubmitting: React.FC<IAutoSubmitting> = ({children, updatedFieldsArray}) => {
    const {submitForm, isSubmitting, setSubmitting} = useFormikContext();
    const {setProcessingOpen} = useContext(ProcessingContext);

    useEffect(() => {
        if (isSubmitting) {
            setProcessingOpen(true)
        }
    }, [isSubmitting])

    useEffect(() => {
        if (isSubmitting && !updatedFieldsArray.length) {
            submitForm()
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }, [isSubmitting, updatedFieldsArray.length])
    return (<>{children}</>);
}